import EducationComponent from "../../Components/EducationComponent/EducationComponent";
import ExperienceComponent from "../../Components/ExperienceComponent/ExperienceComponent";
import ToolsComponent from "../../Components/ToolsComponent/ToolsComponent";


export default function EducationPage(){
    return(
        <>
            <EducationComponent/> 
            <ExperienceComponent/>
            <ToolsComponent/>
        </>
    );
}